import inherits from 'inherits-browser';
import BaseRenderer from 'diagram-js/lib/draw/BaseRenderer';
import { isLabel } from 'diagram-js/lib/util/ModelUtil';
import { append as svgAppend, classes as svgClasses } from 'tiny-svg';
import { getLabel } from 'bpmn-js/lib/util/LabelUtil';

const HIGH_PRIORITY = 1500;
const PADDING = 7;

/**
 * Custom renderer for external labels.
 *
 * The default bpmn-js renderer wraps external label text inside a fixed
 * 90×30 box, which means resizing the label shape does not change where
 * the text wraps. This renderer wraps using the actual element bounds, so
 * making a label wider lets more text fit on a single line.
 */
export default function CustomLabelRenderer(eventBus, textRenderer) {
  BaseRenderer.call(this, eventBus, HIGH_PRIORITY);

  this._textRenderer = textRenderer;
}

inherits(CustomLabelRenderer, BaseRenderer);

CustomLabelRenderer.$inject = ['eventBus', 'textRenderer'];

CustomLabelRenderer.prototype.canRender = function(element) {
  return isLabel(element);
};

CustomLabelRenderer.prototype.drawShape = function(parentGfx, element) {
  const text = getLabel(element) || '';

  const wrapWidth = Math.max(20, (element.width || 90) - PADDING);
  const wrapHeight = Math.max(20, (element.height || 30) - PADDING);

  const textElement = this._textRenderer.createText(text, {
    box: {
      width: wrapWidth,
      height: wrapHeight,
      x: element.width / 2,
      y: element.height / 2
    },
    style: this._textRenderer.getExternalStyle(),
    align: 'center-middle',
    padding: PADDING / 2
  });

  svgClasses(textElement).add('djs-label');
  svgAppend(parentGfx, textElement);

  return textElement;
};

CustomLabelRenderer.prototype.getShapePath = function(shape) {
  const x = shape.x;
  const y = shape.y;
  const width = shape.width;
  const height = shape.height;

  return [
    ['M', x, y],
    ['l', width, 0],
    ['l', 0, height],
    ['l', -width, 0],
    ['z']
  ];
};
